import { DetailsListLayoutMode, IColumn, IGroup, IObjectWithKey, SelectionMode } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { bcbs_config_attributeid_BCCAdmin, bcbs_config_attributeid_BillGroup, bcbs_config_attributeid_CoverageList, bcbs_config_attributeid_FeeType, pepmFeeType, pepmPerTierFeeType } from "global/Application";
import { groupByWithAggregate, IReturn, TGroupByAggregate, TGroupByAggregateMethod } from "global/Utility/TSFunctions";
import * as IXrmOptionSet from "model/AttributeOptionSets.type";
import {
    bcbs_bccadmin as IXrmTypes_bcbs_bccadmin,
    bcbs_config_attribute as IXrmTypes_bcbs_config_attribute
} from "model/CRM";
import { useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
    IBooleanValue as FAM_IBooleanValue,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IStringValue as FAM_IStringValue
} from "../../model/FlexibleAttributeModel";
import { Stack } from '@fluentui/react';

import { StickyDetailsList } from "../../components/layout/StickyDetailList";
import Formatters from "../../global/Utility/Formatters";
import { $att_$fees_and_premiums_$bcbs_attributeset_fee_id, $att_$fees_and_premiums_$bcbs_concessionamount_id } from "model/ConfigAttributeConstants";
interface IProps extends TComponentConnectedProps {
}


interface IItem extends IObjectWithKey {
    feesAndPremiumName: string;
    category?: string;
    'Family Rate': string,
    "Employee Only Rate": string,
    "Employee + Child(ren) Rate": string,
    "Employee + Spouse Rate": string,
    "Employee + 1 (Child) Rate": string,
    "Two-Person Rate": string,
    "Employee + 2 Dependents Rate": string,
    "Concession Amount": string,
    "billGroup": boolean;
    feeTypeName: string;
    stopLossTypeName: string;
}

interface ICustomColumn<T> extends IColumn {
    data?: T
}

type TColumn = ICustomColumn<IXrmTypes_bcbs_config_attribute>

const MonthlyRecurringFeesAgg = (props: IProps) => {
    const highlightStyles = {backgroundColor: 'yellow'};
    const feeSummaryColumns = useMemo(() => {
        const feeSummaryColumns: TColumn[] = [];

        // columns.push({
        //     key: 'category',
        //     name: 'Category',
        //     fieldName: 'category',
        //     minWidth: 100,
        //     maxWidth: 200,
        //     isResizable: true,
        // });

        feeSummaryColumns.push({
            key: 'feesAndPremiumName',
            name: 'Fees And Premium',
            fieldName: 'feesAndPremiumName',
            minWidth: 120,
            maxWidth: 160,
            isResizable: true,
        });

        bcbs_config_attributeid_CoverageList.forEach(e => {
            const configAttribute = props.state.data.config.cache.map_bcbs_config_attribute[e];
            feeSummaryColumns.push({
                key: configAttribute.bcbs_config_attributeid!,
                name: configAttribute.bcbs_name!,
                fieldName: configAttribute.bcbs_name,
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? 100,
                maxWidth: 160,
                isResizable: true,
            })
        });

        return feeSummaryColumns.map((c) => {
            delete c.onRender;
            return c;
        });


    }, []);

    const stopLossColumns = useMemo(() => {
        const stopLossColumns: TColumn[] = [];

        // columns.push({
        //     key: 'category',
        //     name: 'Category',
        //     fieldName: 'category',
        //     minWidth: 100,
        //     maxWidth: 200,
        //     isResizable: true,
        // });

        stopLossColumns.push({
            key: 'feesAndPremiumName',
            name: 'Fees And Premium',
            fieldName: 'feesAndPremiumName',
            minWidth: 120,
            maxWidth: 160,
            isResizable: true,
        });

        bcbs_config_attributeid_CoverageList.forEach(e => {
            const configAttribute = props.state.data.config.cache.map_bcbs_config_attribute[e];
            stopLossColumns.push({
                key: configAttribute.bcbs_config_attributeid!,
                name: configAttribute.bcbs_name!,
                fieldName: configAttribute.bcbs_name,
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? 100,
                maxWidth: 160,
                isResizable: true,
                data: configAttribute,
            })
        })

        const concessionAmountIndex = stopLossColumns.findIndex(q => q.data?.bcbs_config_attributeid === $att_$fees_and_premiums_$bcbs_concessionamount_id)
        stopLossColumns.splice(concessionAmountIndex, 1);
        return stopLossColumns.map((c) => {
            delete c.onRender;
            return c;
        });

        return stopLossColumns;
    }, []);

        let feeSummaryRowsLeftHold: IItem[] = [];
        let feeSummaryRowsRightHold: IItem[] = [];

        let stopLossRowsLeftHold: IItem[] = [];
        let stopLossRowsRightHold: IItem[] = [];

        // fee config:
        const attributeFee = props.state.data.config.cache.map_bcbs_config_attribute[$att_$fees_and_premiums_$bcbs_attributeset_fee_id];

        props.state.comp?.leftSnap?.json?.feesAndPremiums.forEach(eachFeePremium => {

            if (eachFeePremium.deactivated)
                return;

            // defaults
            eachFeePremium.attributeSets.forEach(eachAttribute => {
                let bccAdmin: IXrmTypes_bcbs_bccadmin | null = null;

                const item: IItem = {
                    key: eachAttribute.id,
                    billGroup: false,
                    feesAndPremiumName: eachFeePremium.name
                } as IItem;

                // Extract
                // ----------------------
                // Pick only FEE attribute set
                if (eachAttribute.attributeSetRef.id !== attributeFee._bcbs_config_masterattributeid_value)
                    return;

                if (eachAttribute.deactivated)
                    return;

                // Transform
                // ----------------------
                eachAttribute.fields.forEach(eachField => {
                    const config = props.state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];

                    if (config.bcbs_config_attributeid === bcbs_config_attributeid_BCCAdmin) {

                        // is this field a BCC Admin field?
                        // its used as a criteria to aggregate on for calculations

                        const value = eachField?.values?.[0]?.value as FAM_IEntityReferenceValue;

                        if (value) {
                            // lets find the category selected in bcc admin
                            bccAdmin = props.state.data.config.cache.map_bcbs_bccadmin[value.id];

                            if (bccAdmin._bcbs_categoryid_value) {
                                const category = props.state.data.config.cache.map_bcbs_config_category[bccAdmin._bcbs_categoryid_value!];
                                if (category)
                                    item.category = category.bcbs_name;
                            } else {
                                console.warn("BCC admin is missing a category identifier.", bccAdmin);
                            }
                        }

                    } else if (config.bcbs_config_attributeid === bcbs_config_attributeid_BillGroup) {

                        // is this field "Bill Group" ?
                        // its used as a criteria to include or not

                        const value = eachField?.values?.[0]?.value as FAM_IBooleanValue;
                        if (value)
                            item.billGroup = value.value;

                    } else if (config.bcbs_config_attributeid === bcbs_config_attributeid_FeeType) {

                        // is this field "Fee Type" ?
                        // its used as a criteria to include or not

                        const value = eachField?.values?.[0]?.value as FAM_IEntityReferenceValue;
                        if (value)
                            item.feeTypeName = value.name;

                    } else if (bcbs_config_attributeid_CoverageList.includes(config.bcbs_config_attributeid!)) {

                        // any of or expected fields
                        const property = config.bcbs_name as (keyof typeof item);
                        const value = eachField?.values?.[0]?.value as FAM_IStringValue;

                        if (value)
                            (item[property] as string) = value.value;
                    }
                });
                
                // Load
                // ----------------------
                    feeSummaryRowsLeftHold.push(item);
                
                if (bccAdmin) {

                    // TODO typescript appears to have bug, assumes eachAttributeBccAdmin:never; get assigned in field aggregate
                    const _bccAdmin = bccAdmin as IXrmTypes_bcbs_bccadmin;

                    if (_bccAdmin.bcbs_stoplosstypecode === IXrmOptionSet.bcbs_bccadmin.bcbs_stoplosstypecode["Aggregate(808900000)"].value) {
                        item.stopLossTypeName = 'Aggregate'
                        stopLossRowsLeftHold.push(item);
                    }

                    if (_bccAdmin.bcbs_stoplosstypecode === IXrmOptionSet.bcbs_bccadmin.bcbs_stoplosstypecode["Specific(808900001)"].value) {
                        item.stopLossTypeName = 'Specific'
                        stopLossRowsLeftHold.push(item);
                    }

                }

            })

        });
        props.state.comp?.rightSnap?.json?.feesAndPremiums.forEach(eachFeePremium => {

            if (eachFeePremium.deactivated)
                return;

            // defaults
            eachFeePremium.attributeSets.forEach(eachAttribute => {
                let bccAdmin: IXrmTypes_bcbs_bccadmin | null = null;

                const item: IItem = {
                    key: eachAttribute.id,
                    billGroup: false,
                    feesAndPremiumName: eachFeePremium.name
                } as IItem;

                // Extract
                // ----------------------
                // Pick only FEE attribute set
                if (eachAttribute.attributeSetRef.id !== attributeFee._bcbs_config_masterattributeid_value)
                    return;

                if (eachAttribute.deactivated)
                    return;

                // Transform
                // ----------------------
                eachAttribute.fields.forEach(eachField => {
                    const config = props.state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];

                    if (config.bcbs_config_attributeid === bcbs_config_attributeid_BCCAdmin) {

                        // is this field a BCC Admin field?
                        // its used as a criteria to aggregate on for calculations

                        const value = eachField?.values?.[0]?.value as FAM_IEntityReferenceValue;

                        if (value) {
                            // lets find the category selected in bcc admin
                            bccAdmin = props.state.data.config.cache.map_bcbs_bccadmin[value.id];

                            if (bccAdmin._bcbs_categoryid_value) {
                                const category = props.state.data.config.cache.map_bcbs_config_category[bccAdmin._bcbs_categoryid_value!];
                                if (category)
                                    item.category = category.bcbs_name;
                            } else {
                                console.warn("BCC admin is missing a category identifier.", bccAdmin);
                            }
                        }

                    } else if (config.bcbs_config_attributeid === bcbs_config_attributeid_BillGroup) {

                        // is this field "Bill Group" ?
                        // its used as a criteria to include or not

                        const value = eachField?.values?.[0]?.value as FAM_IBooleanValue;
                        if (value)
                            item.billGroup = value.value;

                    } else if (config.bcbs_config_attributeid === bcbs_config_attributeid_FeeType) {

                        // is this field "Fee Type" ?
                        // its used as a criteria to include or not

                        const value = eachField?.values?.[0]?.value as FAM_IEntityReferenceValue;
                        if (value)
                            item.feeTypeName = value.name;

                    } else if (bcbs_config_attributeid_CoverageList.includes(config.bcbs_config_attributeid!)) {

                        // any of or expected fields
                        const property = config.bcbs_name as (keyof typeof item);
                        const value = eachField?.values?.[0]?.value as FAM_IStringValue;

                        if (value)
                            (item[property] as string) = value.value;
                    }
                });

                // Load
                // ----------------------
                feeSummaryRowsRightHold.push(item);

                if (bccAdmin) {

                    // TODO typescript appears to have bug, assumes eachAttributeBccAdmin:never; get assigned in field aggregate
                    const _bccAdmin = bccAdmin as IXrmTypes_bcbs_bccadmin;

                    if (_bccAdmin.bcbs_stoplosstypecode === IXrmOptionSet.bcbs_bccadmin.bcbs_stoplosstypecode["Aggregate(808900000)"].value) {
                        item.stopLossTypeName = 'Aggregate'
                        stopLossRowsRightHold.push(item);
                    }

                    if (_bccAdmin.bcbs_stoplosstypecode === IXrmOptionSet.bcbs_bccadmin.bcbs_stoplosstypecode["Specific(808900001)"].value) {
                        item.stopLossTypeName = 'Specific'
                        stopLossRowsRightHold.push(item);
                    }

                }

            })

        });
        const stopLossRowsLeft = props.state.status.displayAll ? stopLossRowsLeftHold : stopLossRowsLeftHold.filter((f: IItem) =>
            stopLossRowsRightHold.findIndex((fr: IItem) => fr.feesAndPremiumName === f.feesAndPremiumName &&
                fr["Two-Person Rate"] === f["Two-Person Rate"] &&
                fr["Concession Amount"] === f["Concession Amount"] &&
                fr["Employee + Child(ren) Rate"]=== f["Employee + Child(ren) Rate"] &&
                fr["Employee + Spouse Rate"] === f["Employee + Spouse Rate"] &&
                fr["Employee + 1 (Child) Rate"] === f["Employee + 1 (Child) Rate"] &&
                fr["Employee + 2 Dependents Rate"] === f["Employee + 2 Dependents Rate"] &&
                fr["Employee Only Rate"] === f["Employee Only Rate"] &&
                fr["Family Rate"] === f["Family Rate"] &&
                fr.feeTypeName === f.feeTypeName &&
                fr.stopLossTypeName === f.stopLossTypeName &&
            fr.billGroup === f.billGroup &&
            fr.category === f.category) < 0 );
        const stopLossRowsRight = props.state.status.displayAll ? stopLossRowsRightHold :stopLossRowsRightHold.filter((f: IItem) => stopLossRowsLeftHold.findIndex((fr: IItem) => fr.feesAndPremiumName === f.feesAndPremiumName &&
            fr["Two-Person Rate"] === f["Two-Person Rate"] &&
            fr["Concession Amount"] === f["Concession Amount"] &&
            fr["Employee + Child(ren) Rate"]=== f["Employee + Child(ren) Rate"] &&
            fr["Employee + Spouse Rate"] === f["Employee + Spouse Rate"] &&
            fr["Employee + 1 (Child) Rate"] === f["Employee + 1 (Child) Rate"] &&
            fr["Employee + 2 Dependents Rate"] === f["Employee + 2 Dependents Rate"] &&
            fr["Employee Only Rate"] === f["Employee Only Rate"] &&
            fr["Family Rate"] === f["Family Rate"] &&
            fr.feeTypeName === f.feeTypeName &&
            fr.stopLossTypeName === f.stopLossTypeName &&
            fr.billGroup === f.billGroup &&
            fr.category === f.category) < 0 );

        const feeSummaryRowsLeft = props.state.status.displayAll ? feeSummaryRowsLeftHold :feeSummaryRowsLeftHold.filter((f: IItem) => feeSummaryRowsRightHold.findIndex((fr: IItem) => fr.feesAndPremiumName === f.feesAndPremiumName &&
            fr["Two-Person Rate"] === f["Two-Person Rate"] &&
            fr["Concession Amount"] === f["Concession Amount"] &&
            fr["Employee + Child(ren) Rate"]=== f["Employee + Child(ren) Rate"] &&
            fr["Employee + Spouse Rate"] === f["Employee + Spouse Rate"] &&
            fr["Employee + 1 (Child) Rate"] === f["Employee + 1 (Child) Rate"] &&
            fr["Employee + 2 Dependents Rate"] === f["Employee + 2 Dependents Rate"] &&
            fr["Employee Only Rate"] === f["Employee Only Rate"] &&
            fr["Family Rate"] === f["Family Rate"] &&
            fr.feeTypeName === f.feeTypeName &&
            fr.stopLossTypeName === f.stopLossTypeName &&
            fr.billGroup === f.billGroup &&
            fr.category === f.category) < 0 );


        const feeSummaryRowsRight = props.state.status.displayAll ? feeSummaryRowsRightHold :feeSummaryRowsRightHold.filter((f: IItem) => feeSummaryRowsLeftHold.findIndex((fr: IItem) => fr.feesAndPremiumName === f.feesAndPremiumName &&
            fr["Two-Person Rate"] === f["Two-Person Rate"] &&
            fr["Concession Amount"] === f["Concession Amount"] &&
            fr["Employee + Child(ren) Rate"]=== f["Employee + Child(ren) Rate"] &&
            fr["Employee + Spouse Rate"] === f["Employee + Spouse Rate"] &&
            fr["Employee + 1 (Child) Rate"] === f["Employee + 1 (Child) Rate"] &&
            fr["Employee + 2 Dependents Rate"] === f["Employee + 2 Dependents Rate"] &&
            fr["Employee Only Rate"] === f["Employee Only Rate"] &&
            fr["Family Rate"] === f["Family Rate"] &&
            fr.feeTypeName === f.feeTypeName &&
            fr.stopLossTypeName === f.stopLossTypeName &&
            fr.billGroup === f.billGroup &&
            fr.category === f.category) < 0 );


        const aggSum: TGroupByAggregateMethod<IItem> = (prev, current, key, row): string => {
            const prevInt = prev ? parseFloat(prev as string) : 0;
            const currentInt = current ? parseFloat(current as string) : 0;

            // we are excluding 'Per Employee Per Month (PEPM)' from aggregate
            if (row.feeTypeName !== pepmFeeType.name && row.feeTypeName !== pepmPerTierFeeType.name)
                return (prevInt).toString();

            // if bill group is Yes?
            if (row.billGroup) {
                return (prevInt + currentInt).toString();
            }
            // 'Concession Amount' ignores bill group in the condition
            if (key === 'Concession Amount') {
                return (prevInt + currentInt).toString();
            }

            return (prevInt).toString();
        };

        // const aggNoOp = (prev: string, current: string, row: any): string => {
        //     return '';
        // };

        const aggLastString: TGroupByAggregateMethod<IItem> = (prev, current, key, row) => {
            return current;
        };

        const aggPredicate: TGroupByAggregate<IItem> = {
            "feesAndPremiumName": aggLastString,
            "Employee Only Rate": aggSum,
            'Family Rate': aggSum,
            "Employee + Child(ren) Rate": aggSum,
            "Employee + Spouse Rate": aggSum,
            "Employee + 1 (Child) Rate": aggSum,
            "Two-Person Rate": aggSum,
            "Employee + 2 Dependents Rate": aggSum,
            "Concession Amount": aggSum,
        }

        function aggregateToGridGroupByRef<T>(groupKeyValues: Record<string, IReturn<T>>, depth: number, parentGroupByRef: IGroup, itemsByRef: T[], maxDepth = -1) {
            // lets extract
            const continueGrouping = maxDepth === -1 || depth <= maxDepth;

            for (const [key, value] of Object.entries(groupKeyValues)) {

                if (value.grouping) {
                    const startIndex = itemsByRef.length;

                    const scopeGroup = {
                        key: key,
                        name: key,
                        startIndex: startIndex,
                        count: 0,
                        level: depth - 1,
                        isCollapsed: depth > 0 ? true : false
                    } as IGroup;

                    if (continueGrouping) {
                        if (!parentGroupByRef.children)
                            parentGroupByRef.children = [];

                        parentGroupByRef.children.push(scopeGroup);
                    }

                    aggregateToGridGroupByRef(value.grouping, depth + 1, scopeGroup, itemsByRef, maxDepth);
                    parentGroupByRef.count = parentGroupByRef.count + scopeGroup.count

                } else {
                    const startIndex = itemsByRef.length;
                    let count = 0;

                    // value.rows?.forEach(r => newItems.push(r));
                    if (value.rowsAggregate) {
                        itemsByRef.push(value.rowsAggregate);
                        count = 1;
                    } else {
                        value.rows?.forEach(r => itemsByRef.push(r));
                        count = value.rows?.length ?? count;
                    }

                    const scopeGroup = {
                        key: key,
                        name: key,
                        startIndex: startIndex,
                        // count: value.rows?.length ?? 0,
                        count: count,
                        level: depth,
                        isCollapsed: depth > 0 ? true : false
                    } as IGroup;

                    if (continueGrouping) {

                        if (!parentGroupByRef.children)
                            parentGroupByRef.children = [];

                        parentGroupByRef.children.push(scopeGroup);
                    }

                    parentGroupByRef.count = parentGroupByRef.count + scopeGroup.count

                }
            }
        }

        const feeSummaryGroupByLeft = groupByWithAggregate(feeSummaryRowsLeft, ['category', 'feesAndPremiumName'], aggPredicate);
        const feeSummaryGroupContainerLeft: IGroup = {} as IGroup;
        let feeSummaryItemsLeft: any[] = [];
        aggregateToGridGroupByRef(
            {root: feeSummaryGroupByLeft},
            0,
            feeSummaryGroupContainerLeft,
            feeSummaryItemsLeft
        );
        const feeSummaryGroupsLeft = feeSummaryGroupContainerLeft.children?.[0].children!;
        // I dont want the inner aggregates, only first level after root
        if (feeSummaryGroupsLeft)
            feeSummaryGroupsLeft.forEach(q => q.children = []);


        const feeSummaryGroupByRight = groupByWithAggregate(feeSummaryRowsRight, ['category', 'feesAndPremiumName'], aggPredicate);
        const feeSummaryGroupContainerRight: IGroup = {} as IGroup;
        let feeSummaryItemsRight: any[] = [];
        aggregateToGridGroupByRef(
            {root: feeSummaryGroupByRight},
            0,
            feeSummaryGroupContainerRight,
            feeSummaryItemsRight
        );
        const feeSummaryGroupsRight = feeSummaryGroupContainerRight.children?.[0].children!;
        // I dont want the inner aggregates, only first level after root
        if (feeSummaryGroupsRight)
            feeSummaryGroupsRight.forEach(q => q.children = []);

        const stopLossGroupByLeft = groupByWithAggregate(stopLossRowsLeft, ['stopLossTypeName', 'category', 'feesAndPremiumName'], aggPredicate);
        const stopLossGroupRootLeft: IGroup = {} as IGroup;
        let stopLossItemsLeft: any[] = [];
        aggregateToGridGroupByRef(
            {root: stopLossGroupByLeft},
            0,
            stopLossGroupRootLeft,
            stopLossItemsLeft,
            2
        );
        const stopLossGroupsLeft = stopLossGroupRootLeft.children?.[0].children!;
        // if (stopLossGroups)
        //     stopLossGroups.forEach(q => q.children?.forEach(w=>w.children = []));
        const stopLossGroupByRight = groupByWithAggregate(stopLossRowsRight, ['stopLossTypeName', 'category', 'feesAndPremiumName'], aggPredicate);
        const stopLossGroupRootRight: IGroup = {} as IGroup;
        let stopLossItemsRight: any[] = [];
        aggregateToGridGroupByRef(
            {root: stopLossGroupByRight},
            0,
            stopLossGroupRootRight,
            stopLossItemsRight,
            2
        );
        const stopLossGroupsRight = stopLossGroupRootRight.children?.[0].children!;
        // if (stopLossGroups)
        //     stopLossGroups.forEach(q => q.children?.forEach(w=>w.children = []));

     feeSummaryItemsLeft = feeSummaryItemsLeft.map((f) => {
          const rightMatch = feeSummaryItemsRight.find(fr => fr.feesAndPremiumName === f.feesAndPremiumName);
          const newRow = f;
          if(!rightMatch || newRow["Concession Amount"] !== rightMatch["Concession Amount"])
              newRow["Concession Amount"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Concession Amount"])}</span>;
          else
              newRow["Concession Amount"]=Formatters.ToCurrencyUSD(newRow["Concession Amount"])
         if(!rightMatch || newRow["Employee + Child(ren) Rate"] !== rightMatch["Employee + Child(ren) Rate"])
              newRow["Employee + Child(ren) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])}</span>;
         else
             newRow["Employee + Child(ren) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"]) 
         if(!rightMatch || newRow["Employee + Spouse Rate"] !== rightMatch["Employee + Spouse Rate"])
              newRow["Employee + Spouse Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])}</span>;
         else
             newRow["Employee + Spouse Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])
         if(!rightMatch || newRow["Employee + 1 (Child) Rate"] !== rightMatch["Employee + 1 (Child) Rate"])
              newRow["Employee + 1 (Child) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])}</span>;
         else
             newRow["Employee + 1 (Child) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])
         if(!rightMatch || newRow["Employee + 2 Dependents Rate"] !== rightMatch["Employee + 2 Dependents Rate"])
              newRow["Employee + 2 Dependents Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])}</span>;
         else
             newRow["Employee + 2 Dependents Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])
         if(!rightMatch || newRow["Employee Only Rate"] !== rightMatch["Employee Only Rate"])
              newRow["Employee Only Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])}</span>;
         else
             newRow["Employee Only Rate"]=Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])
         if(!rightMatch || newRow["Family Rate"] !== rightMatch["Family Rate"])
              newRow["Family Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Family Rate"])}</span>;
         else
             newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
         if(!rightMatch || newRow["Two-Person Rate"] !== rightMatch["Two-Person Rate"])
              newRow["Two-Person Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Two-Person Rate"])}</span>;
         else
             newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
         return newRow;
  
      });
      feeSummaryItemsRight = feeSummaryItemsRight.map((f) => {
          const leftMatch = feeSummaryItemsLeft.find(fr => fr.feesAndPremiumName === f.feesAndPremiumName);
          const newRow = f;
          if(!leftMatch || newRow["Concession Amount"] !== leftMatch["Concession Amount"])
              newRow["Concession Amount"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Concession Amount"])}</span>;
          else
              newRow["Concession Amount"]=Formatters.ToCurrencyUSD(newRow["Concession Amount"])
          if(!leftMatch || newRow["Employee + Child(ren) Rate"] !== leftMatch["Employee + Child(ren) Rate"])
              newRow["Employee + Child(ren) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])}</span>;
          else
              newRow["Employee + Child(ren) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])
          if(!leftMatch || newRow["Employee + Spouse Rate"] !== leftMatch["Employee + Spouse Rate"])
              newRow["Employee + Spouse Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])}</span>;
          else
              newRow["Employee + Spouse Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])
          if(!leftMatch || newRow["Employee + 1 (Child) Rate"] !== leftMatch["Employee + 1 (Child) Rate"])
              newRow["Employee + 1 (Child) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])}</span>;
          else
              newRow["Employee + 1 (Child) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])
          if(!leftMatch || newRow["Employee + 2 Dependents Rate"] !== leftMatch["Employee + 2 Dependents Rate"])
              newRow["Employee + 2 Dependents Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])}</span>;
          else
              newRow["Employee + 2 Dependents Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])
          if(!leftMatch || newRow["Employee Only Rate"] !== leftMatch["Employee Only Rate"])
              newRow["Employee Only Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])}</span>;
          else
              newRow["Employee Only Rate"]=Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])
          if(!leftMatch || newRow["Family Rate"] !== leftMatch["Family Rate"])
              newRow["Family Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Family Rate"])}</span>;
          else
              newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
          if(!leftMatch || newRow["Two-Person Rate"] !== leftMatch["Two-Person Rate"])
              newRow["Two-Person Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Two-Person Rate"])}</span>;
          else
              newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
          return newRow;
  
      });
    stopLossItemsLeft = stopLossItemsLeft.map((f) => {
        const rightMatch = stopLossItemsRight.find(fr => fr.feesAndPremiumName === f.feesAndPremiumName);
        const newRow = f;
        if(!rightMatch || newRow["Concession Amount"] !== rightMatch["Concession Amount"])
            newRow["Concession Amount"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Concession Amount"])}</span>;
        else
            newRow["Concession Amount"]=Formatters.ToCurrencyUSD(newRow["Concession Amount"])
        if(!rightMatch || newRow["Employee + Child(ren) Rate"] !== rightMatch["Employee + Child(ren) Rate"])
            newRow["Employee + Child(ren) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])}</span>;
        else
            newRow["Employee + Child(ren) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])
        if(!rightMatch || newRow["Employee + Spouse Rate"] !== rightMatch["Employee + Spouse Rate"])
            newRow["Employee + Spouse Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])}</span>;
        else
            newRow["Employee + Spouse Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])
        if(!rightMatch || newRow["Employee + 1 (Child) Rate"] !== rightMatch["Employee + 1 (Child) Rate"])
            newRow["Employee + 1 (Child) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])}</span>;
        else
            newRow["Employee + 1 (Child) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])
        if(!rightMatch || newRow["Employee + 2 Dependents Rate"] !== rightMatch["Employee + 2 Dependents Rate"])
            newRow["Employee + 2 Dependents Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])}</span>;
        else
            newRow["Employee + 2 Dependents Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])
        if(!rightMatch || newRow["Employee Only Rate"] !== rightMatch["Employee Only Rate"])
            newRow["Employee Only Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])}</span>;
        else
            newRow["Employee Only Rate"]=Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])
        if(!rightMatch || newRow["Family Rate"] !== rightMatch["Family Rate"])
            newRow["Family Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Family Rate"])}</span>;
        else
            newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
        if(!rightMatch || newRow["Two-Person Rate"] !== rightMatch["Two-Person Rate"])
            newRow["Two-Person Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Two-Person Rate"])}</span>;
        else
            newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
        return newRow;

    });
    stopLossItemsRight = stopLossItemsRight.map((f) => {
        const leftMatch = stopLossItemsLeft.find(fr => fr.feesAndPremiumName === f.feesAndPremiumName);
        const newRow = f;
        if(!leftMatch || newRow["Concession Amount"] !== leftMatch["Concession Amount"])
            newRow["Concession Amount"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Concession Amount"])}</span>;
        else
            newRow["Concession Amount"]=Formatters.ToCurrencyUSD(newRow["Concession Amount"])
        if(!leftMatch || newRow["Employee + Child(ren) Rate"] !== leftMatch["Employee + Child(ren) Rate"])
            newRow["Employee + Child(ren) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])}</span>;
        else
            newRow["Employee + Child(ren) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Child(ren) Rate"])
        if(!leftMatch || newRow["Employee + Spouse Rate"] !== leftMatch["Employee + Spouse Rate"])
            newRow["Employee + Spouse Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])}</span>;
        else
            newRow["Employee + Spouse Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + Spouse Rate"])
        if(!leftMatch || newRow["Employee + 1 (Child) Rate"] !== leftMatch["Employee + 1 (Child) Rate"])
            newRow["Employee + 1 (Child) Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])}</span>;
        else
            newRow["Employee + 1 (Child) Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 1 (Child) Rate"])
        if(!leftMatch || newRow["Employee + 2 Dependents Rate"] !== leftMatch["Employee + 2 Dependents Rate"])
            newRow["Employee + 2 Dependents Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])}</span>;
        else
            newRow["Employee + 2 Dependents Rate"]=Formatters.ToCurrencyUSD(newRow["Employee + 2 Dependents Rate"])
        if(!leftMatch || newRow["Employee Only Rate"] !== leftMatch["Employee Only Rate"])
            newRow["Employee Only Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])}</span>;
        else
            newRow["Employee Only Rate"]=Formatters.ToCurrencyUSD(newRow["Employee Only Rate"])
        if(!leftMatch || newRow["Family Rate"] !== leftMatch["Family Rate"])
            newRow["Family Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Family Rate"])}</span>;
        else
            newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
        if(!leftMatch || newRow["Two-Person Rate"] !== leftMatch["Two-Person Rate"])
            newRow["Two-Person Rate"] =<span style={highlightStyles}>{Formatters.ToCurrencyUSD(newRow["Two-Person Rate"])}</span>;
        else
            newRow["Family Rate"]=Formatters.ToCurrencyUSD(newRow["Family Rate"])
        return newRow;

    });
        let dataSource =  {
            left: {
                feeSummary: {
                    groups: feeSummaryGroupsLeft,
                    items: feeSummaryItemsLeft
                },
                stopLoss: {
                    groups: stopLossGroupsLeft,
                    items: stopLossItemsLeft
                },
            },
            right: {
                feeSummary: {
                    groups: feeSummaryGroupsRight,
                    items: feeSummaryItemsRight
                },
                stopLoss: {
                    groups: stopLossGroupsRight,
                    items: stopLossItemsRight
                },
            }
        };

    return <>{(dataSource.left.feeSummary.items.length > 0 || dataSource.right.feeSummary.items.length > 0) &&
        <CustomPanel title={'Fees Summary'}
                     canCollapse={true}
                     defaultCollapsed={false}
                     storageId={'monthlyRecurringFees'}
        ><Stack horizontal>
            <StickyDetailsList
                items={dataSource.left.feeSummary.items}
                groups={dataSource.left.feeSummary.groups}
                columns={feeSummaryColumns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.fixedColumns}
                groupProps={{
                    showEmptyGroups: true,
                }}
            />
            <StickyDetailsList
                items={dataSource.right.feeSummary.items}
                groups={dataSource.right.feeSummary.groups}
                columns={feeSummaryColumns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.fixedColumns}
                groupProps={{
                    showEmptyGroups: true,
                }}
            />
        </Stack>
        </CustomPanel>
    }{(dataSource.left.stopLoss.items.length > 0 || dataSource.right.stopLoss.items.length > 0) &&
        <CustomPanel title={'Stop Loss Summary'}
                     canCollapse={true}
                     defaultCollapsed={false}
                     storageId={'stopLossSummary'}
        ><Stack horizontal>
            <StickyDetailsList
                items={dataSource.left.stopLoss.items}
                groups={dataSource.left.stopLoss.groups}
                columns={stopLossColumns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.fixedColumns}
                groupProps={{
                    showEmptyGroups: true,
                }}
            />
            <StickyDetailsList
                items={dataSource.right.stopLoss.items}
                groups={dataSource.right.stopLoss.groups}
                columns={stopLossColumns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.fixedColumns}
                groupProps={{
                    showEmptyGroups: true,
                }}
            />
        </Stack>
        </CustomPanel>}
    </>
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(MonthlyRecurringFeesAgg);
